module.exports = __webpack_public_path__ + "img/hr-tree-01-b-leaves.43b7437b.png";